import * as firebase from 'firebase/app'
import 'firebase/firestore'

// firebase init - add your own config here
var firebaseConfig = {
    apiKey: "AIzaSyAWzXmzfdQn9TOv8CPoQ82kUOw6f2E-r2o",
    authDomain: "faberxemergency.firebaseapp.com",
    databaseURL: "https://faberxemergency.firebaseio.com",
    projectId: "faberxemergency",
    storageBucket: "faberxemergency.appspot.com",
    messagingSenderId: "721582866778",
    appId: "1:721582866778:web:898270948090fd05417363"
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()

// collection references
const subscriptionsCollection = db.collection('subscriptions')

// export utils/refs
export {
    db,
    subscriptionsCollection
}
